import { CircularProgress } from '@material-ui/core';

import { useLoadingCatalog } from './hooks';

import makeClasses from './LoadingCatalog.style';

export function LoadingCatalog() {
  const { lang } = useLoadingCatalog();

  const _classes = makeClasses();

  return (
    <section className={_classes.root}>
      <CircularProgress
        size='3rem'
        thickness={6}
        classes={{ colorPrimary: _classes.spinner }}
      />
      <h1 className={_classes.title}>{lang.title}</h1>
      <p className={_classes.description}>{lang.description}</p>
    </section>
  );
}
